<template>
  <v-navigation-drawer
    v-model="showSlideout"
    fixed
    temporary
    right
    :width="width"
    stateless
    :hide-overlay="hideSlideoutOverlay"
  >
    <BadgeCreator
      v-if="slideoutData && slideoutData.type === 'badgeCreator'"
      :issuerEntityId="slideoutData.issuerEntityId"
      :open="showSlideout">
    </BadgeCreator>
    <PlaylistAttachmentPicker
      v-show="slideoutData && slideoutData.type === 'playlistAttachmentPicker'"
      :open="showSlideout">
    </PlaylistAttachmentPicker>
    <PlaylistBulbPicker
      v-show="slideoutData && slideoutData.type === 'playlistBulbPicker'"
      :open="showSlideout">
    </PlaylistBulbPicker>
    <PlaylistBulbSettings
      v-show="slideoutData && slideoutData.type === 'playlistBulbSettings'"
      :open="showSlideout">
    </PlaylistBulbSettings>
    <TextEditor
      v-if="(
        slideoutData
        && slideoutData.type === 'textEditor'
      )"
      :open="showSlideout"
    >
    </TextEditor>
  </v-navigation-drawer>
</template>

<script>
import {
  mapState,
  mapMutations,
} from 'vuex';
import _ from 'lodash';
import { mapFields } from 'vuex-map-fields';

// Custom components:
import BadgeCreator from './slideout-views/BadgeCreator.vue';
import PlaylistAttachmentPicker from './slideout-views/PlaylistAttachmentPicker.vue';
import PlaylistBulbPicker from './slideout-views/PlaylistBulbPicker.vue';
import PlaylistBulbSettings from './slideout-views/PlaylistBulbSettings.vue';
import TextEditor from './slideout-views/TextEditor.vue';

export default {
  name: 'Slideout',
  components: {
    BadgeCreator,
    PlaylistAttachmentPicker,
    PlaylistBulbPicker,
    PlaylistBulbSettings,
    TextEditor,
  },
  data: () => ({
    width: '70%',
  }),
  computed: {
    ...mapState([
      'slideoutData',
    ]),
    ...mapFields([
      'showSlideout',
    ]),
    hideSlideoutOverlay() {
      return (
        !this.slideoutData
        || _.get(this.slideoutData, 'type', false) === 'playlistBulbPicker'
      );
    },
  },
  methods: {
    ...mapMutations([
      'setSlideout',
    ]),
  },
  watch: {
    slideoutData(newValue, oldValue) { // eslint-disable-line
      if (
        newValue
        && (newValue.type === 'playlistBulbPicker')
      ) this.width = '70%';
      else this.width = '40%';
    },
  },
};
</script>
